module.exports = __webpack_public_path__ + "static/img/m3_t4a_text2.5df9e878.jpg";